import { FunctionComponent, useState } from 'react';
import ArrowLeft from '../../icons/ArrowLeft';
import Image from "next/legacy/image";
import Testimonial from 'wwg-utilities/dist/types/testimonial';
import Program from 'wwg-utilities/dist/collections/program';

interface TestimonialsProps {
    program: Program;
}

const Testimonials: FunctionComponent<TestimonialsProps> = ({
    program,
}) => {
    const testimonials = program.testimonials as Testimonial[];

    const [activeIndex, setActiveIndex] = useState(0);

    const next = () => {
        if (activeIndex === testimonials.length - 1) {
            setActiveIndex(0);
        } else {
            const newIndex = activeIndex + 1;
            setActiveIndex(newIndex);
        }
    };

    const prev = () => {
        if (activeIndex === 0) {
            setActiveIndex(testimonials.length - 1);
        } else {
            const newIndex = activeIndex - 1;
            setActiveIndex(newIndex);
        }
    };

    if (!testimonials || !testimonials.length) {
        return <></>;
    }
    return (
        <section className="p-4 bg-md-gray">
            <figure className="flex items-center justify-between">
                <Image
                    className="p-2 bg-primary"
                    src="https://res.cloudinary.com/wherewego/image/upload/v1648310041/WWG2000%20Site%20Photos/o7itziwj1nyfvsnwwsov.svg"
                    blurDataURL="https://res.cloudinary.com/wherewego/image/upload/v1648310041/WWG2000%20Site%20Photos/o7itziwj1nyfvsnwwsov.svg"
                    width={2500} height={2000}
                    layout='responsive'
                    loading='eager'
                    placeholder='blur'
                    alt="Double Quote Icon"
                />
                <figure className="flex">
                    <ArrowLeft
                        onClick={prev}
                        className="w-10 h-10 p-3 mx-1 rounded-full hover:cursor-pointer stroke-white bg-primary"
                    />
                    <ArrowLeft
                        onClick={next}
                        className="w-10 h-10 p-3 mx-1 rotate-180 rounded-full hover:cursor-pointer stroke-white bg-primary"
                    />
                </figure>
            </figure>
            <h3 className="my-3 text-2xl font-bold text-black">Testimonials</h3>
            <section className="relative font-light">
                {testimonials.map((testimonial: Testimonial, index: number) => {
                    return (
                        <div
                            className={` ${activeIndex === index ? 'animate-fade-in  ' : ' hidden'
                                }`}
                        >
                            <p className="text-sm italic">{testimonial.quote}</p>
                            <p className="my-2 text-sm font-bold">
                                {testimonial.author}, {testimonial.relationship}
                            </p>
                        </div>
                    );
                })}
            </section>
        </section>
    );
};

export default Testimonials;
